import React from 'react';
import I18n from 'i18n-js';
import { useUser } from '@reverbdotcom/commons/src/user_hooks';
import { MParticleEventName, trackEvent } from '@reverbdotcom/commons/src/elog/mparticle_tracker';
import { IPrivacyConsentSettings } from '@reverbdotcom/commons/src/google';

import UserPrivacySettingModal from './user_privacy_setting_modal';
import { submitRequest } from './user_privacy_consent_container';

const COMPONENT_NAME = 'UserPrivacySetting';

export default function UserPrivacySetting() {
  const [isModalOpen, setModalOpen] = React.useState(false);

  const user = useUser();

  const [privacyConsentSettings, setPrivacyConsentSettings] = React.useState({
    adData: user.thirdPartyAdDataAllowed,
    adStorage: user.thirdPartyAdStorageAllowed,
    adPersonalization: user.thirdPartyAdPersonalizationAllowed,
    analyticsStorage: user.thirdPartyAnalyticsStorageAllowed,
  } as IPrivacyConsentSettings);

  const closeModal = React.useCallback(() => {
    setModalOpen(false);
  }, []);

  const openModal = React.useCallback(() => {
    setModalOpen(true);

    trackEvent({
      eventName: MParticleEventName.OpenedPrivacySettingsModal,
      componentName: COMPONENT_NAME,
    });
  }, []);

  const handleSubmit = () => {
    submitRequest(privacyConsentSettings, user);
  };

  const updatePrivacySettings = React.useCallback((e) => {
    setPrivacyConsentSettings({
      ...privacyConsentSettings,
      [e.target.id]: e.target.checked,
    } as IPrivacyConsentSettings);
  }, [privacyConsentSettings]);

  return (
    <button
      type="button"
      className="site-footer-v2__link"
      onClick={openModal}
    >
      <UserPrivacySettingModal
        onSubmit={handleSubmit}
        isAdDataChecked={privacyConsentSettings.adData}
        isAdStorageChecked={privacyConsentSettings.adStorage}
        isAdPersonalizationChecked={privacyConsentSettings.adPersonalization}
        isAnalyticsStorageChecked={privacyConsentSettings.analyticsStorage}
        updatePrivacySettings={updatePrivacySettings}
        onClose={closeModal}
        isOpen={isModalOpen}
      />
      {I18n.t('discovery.privacySettingsModal.privacySettings.title')}
    </button>
  );
}
